// Loan Originator (individual) and Loan Origination Company parties.
//
// These are built from the LO's Admin profile (account + company profile), not
// from the loan document, so the exporter must be given those profiles in the
// export context. POINT matches its Originator dropdown to the LoanOriginator
// individual PARTY (name + NMLS); we previously exported neither party, so the
// Originator came through blank. Element order mirrors POINT's own export so it
// stays valid against the MISMO 3.4 XSD.
//
// Appended to the PARTIES element alongside the borrower parties. They carry an
// explicit PartyRoleType (LoanOriginator / LoanOriginationCompany), so a
// consumer keys off the role, not position - our own importer skips any party
// that is not a Borrower (isBorrowerParty).
export function populateOriginatorParties(builder, { accountProfile, companyProfile }) {
  if (accountProfile) {
    const fullName = [
      accountProfile.first_name,
      accountProfile.middle_name,
      accountProfile.last_name
    ]
      .filter(Boolean)
      .join(" ")
      .trim();

    if (fullName || accountProfile.nmls_number) {
      const party = builder.ele("PARTY");
      const individual = party.ele("INDIVIDUAL");
      if (accountProfile.email) {
        individual
          .ele("CONTACT_POINTS")
          .ele("CONTACT_POINT")
          .ele("CONTACT_POINT_EMAIL")
          .ele("ContactPointEmailValue")
          .txt(accountProfile.email);
      }
      if (fullName) {
        individual.ele("NAME").ele("FullName").txt(fullName);
      }
      const role = party.ele("ROLES").ele("ROLE");
      role.att("SequenceNumber", "1");
      role.att("xlink:label", "LOAN_ORIGINATOR_1");
      if (accountProfile.nmls_number) {
        const detail = role
          .ele("LICENSES")
          .ele("LICENSE")
          .ele("LICENSE_DETAIL");
        detail.ele("LicenseAuthorityLevelType").txt("Private");
        detail.ele("LicenseIdentifier").txt(String(accountProfile.nmls_number));
      }
      role.ele("ROLE_DETAIL").ele("PartyRoleType").txt("LoanOriginator");
    }
  }

  if (companyProfile && companyProfile.company_name) {
    const party = builder.ele("PARTY");
    party
      .ele("LEGAL_ENTITY")
      .ele("LEGAL_ENTITY_DETAIL")
      .ele("FullName")
      .txt(companyProfile.company_name);

    if (
      companyProfile.business_address ||
      companyProfile.city ||
      companyProfile.state ||
      companyProfile.zip
    ) {
      const addr = party.ele("ADDRESSES").ele("ADDRESS");
      if (companyProfile.business_address) {
        addr.ele("AddressLineText").txt(companyProfile.business_address);
      }
      if (companyProfile.city) addr.ele("CityName").txt(companyProfile.city);
      if (companyProfile.zip) addr.ele("PostalCode").txt(companyProfile.zip);
      if (companyProfile.state) addr.ele("StateCode").txt(companyProfile.state);
    }

    const role = party.ele("ROLES").ele("ROLE");
    role.att("SequenceNumber", "2");
    role.att("xlink:label", "LOAN_ORIGINATION_COMPANY_2");
    if (companyProfile.company_nmls_number) {
      const detail = role.ele("LICENSES").ele("LICENSE").ele("LICENSE_DETAIL");
      detail.ele("LicenseAuthorityLevelType").txt("Private");
      detail
        .ele("LicenseIdentifier")
        .txt(String(companyProfile.company_nmls_number));
    }
    role.ele("ROLE_DETAIL").ele("PartyRoleType").txt("LoanOriginationCompany");
  }
}
